import React from 'react';
import Layout from 'shared/component/Layout';
import { useSystems } from 'hook/system';
import SystemForm from 'shared/forms/SystemForm';

function SystemPageCreate() {
  const { getCreate, loading, status } = useSystems();

  const formatRequest = (data) => ({
    name: data?.name,
    email: data?.email,
    cpf: data?.cpf,
    rg: data?.rg,
    cell_phone: data?.cell_phone,
    company: { id: data?.company.id },
    group: { id: data?.group.id },
    units: data?.units,
  });

  const formSubmit = ({ data, fileLogo }) => {
    getCreate({
      data: formatRequest(data),
      fileLogo,
      permissions: data?.permissions.map((item) => ({ id: item?.id })),
    });
  };

  return (
    <Layout
      title="Sistemas"
      isLoading={false}
      calendarWeek={false}
      showToday
      backArrow
    >
      <>
        <SystemForm formSubmit={formSubmit} loading={loading} status={status} />
      </>
    </Layout>
  );
}

export default SystemPageCreate;
